module.exports = __webpack_public_path__ + "static/topup-full-bg-3aba6847a8e4a01eed32c314436ab762.png";